import React from 'react';
import InsightsIcon from '@mui/icons-material/Insights';
import DashboardIcon from '@mui/icons-material/Dashboard';
import StorageIcon from '@mui/icons-material/Storage';
import TimelineIcon from '@mui/icons-material/Timeline';

// Display metadata for every tile key that exists, keyed by the tile id
// returned in GET /api/me/entitlements' `tiles` array (see
// server/services/entitlements.js). Home.jsx renders whatever order/count
// that endpoint returns by looking each key up here — adding a tier that
// sees a different tile set is a data change there, not a Home.jsx edit.
export const TILE_REGISTRY = {
  insights: {
    id: 'insights',
    title: 'Survey Insights',
    description: 'Analyse survey responses with AI-powered insights and visualisations',
    icon: <InsightsIcon />,
    path: '/insights',
    color: '#008080',
  },
  dashboard: {
    id: 'dashboard',
    title: 'Survey Dashboard',
    description: 'Monitor survey progress, completion rates, and real-time metrics',
    icon: <DashboardIcon />,
    path: '/dashboard',
    color: '#006666',
  },
  'data-interaction': {
    id: 'data-interaction',
    title: 'Survey Data Interaction',
    description: 'Query, export, and interact with survey data',
    icon: <StorageIcon />,
    path: '/data-interaction',
    color: '#00A0A0',
  },
  'vendor-journey': {
    id: 'vendor-journey',
    title: 'Respondent Journey',
    description: 'Track respondent enrollment, portal access, and completion progress',
    icon: <TimelineIcon />,
    path: '/vendor-journey',
    color: '#5C6BC0',
  },
};
